import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import HeaderTop from './HeaderTop';
import NewHeaderTop from "./NewHeaderTop"

import { getStoreLocation, getNearByStores, cleanDataStoreLocation } from '../../../pages/NewHeader/actions';

export const zipTitle = 'C.P. Ciudad o Tienda';
export const stateTitle = 'Estado';

class HeaderTopContainer extends Component {
  constructor(props) {
    super(props);

    this.initialState = {
      showModalLocationContent: false,
      showModalLocation: true,
      showModalStates: false,
      showModalDetails: false,

      callAllStatesOfContry: false,
      storesForZip: true,
      storesForState: false,
      storeOrCityOrStateName: {
        stateSelected: {},
        zipOrStateSearching: [],
      },
    };

    this.state = { ...this.initialState };
  }

  hideOverlay = () => {
    this.props.cleanDataStoreLocation();
    this.setState({ ...this.initialState, showModalLocationContent: false });

    this.blockScroll();
  }

  blockScroll = () => {
    if (Array.from(document.getElementsByTagName('body'))[0].classList.value === 'noscroll') {
      document.body.classList.remove('noscroll');
    }
  }

  showModalLocationContentUpdate = () => {
    this.props.getStoreLocation();
    this.setState({ ...this.state, showModalLocationContent: !this.state.showModalLocationContent });

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('noscroll');
  }

  showModalLocationUpdate = () =>
    this.setState({ ...this.state, showModalLocation: !this.state.showModalLocation });

  showModalStatesUpdate = () =>
    this.setState({
      ...this.state,
      showModalStates: !this.state.showModalStates,
      showModalLocation: !this.state.showModalLocation,
    });

  showModalDetailsUpdate = (isModLocationActive, isModDetailsActive) =>
    this.setState({
      ...this.state,
      // showModalDetails: !this.state.showModalStates,
      showModalLocation: isModLocationActive,
      showModalDetails: isModDetailsActive,
      // showModalLocation: !this.state.showModalLocation,
    });

  callForSearchStores = (typeButton) => {
    this.props.cleanDataStoreLocation();

    this.setState({
      ...this.state,
      storesForState: (typeButton === stateTitle),
      storesForZip: (typeButton === zipTitle),
    });
  }

  stateOrZipSelectedUpdate = (dataSelected) => {
    this.setState({
      ...this.state,
      storeOrCityOrStateName: {
        ...this.state.storeOrCityOrStateName,
        stateSelected: { ...dataSelected },
      },
    });
    this.props.getNearByStores(dataSelected.nameState);
  }

  callSearchZipStateService = code =>
    this.props.getNearByStores(code);

  render() {
    const {
      getStoreLocation: getStoreLocationFn,
      storeLocationStates,
      linksHeaderTop,
      storeByNear,
      otherSites,
      services,
      home,
    } = this.props;

    const {
      showModalLocationContent,
      showModalLocation,
      showModalDetails,
      showModalStates,
    } = this.state;

    const resultStoreByNear = (storeByNear && storeByNear.data) ? storeByNear : null;
    const withErrorService = (
      (storeByNear && storeByNear.statusCode === 400) || (storeByNear && storeByNear.statusCode === 500)
    )
      ? 'Lo sentimos, ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.'
      : '';

    const textFieldValid = (storeByNear && !storeByNear.data)
      || (storeByNear && storeByNear.data && storeByNear.data.length === 0)
      ? 'Inténtalo después de algún tiempo' : '';

    const { storeName } = this.props;

    return (
      <Fragment>
        <NewHeaderTop
          showModalLocationContent={showModalLocationContent}
          showModalLocationContentUpdate={this.showModalLocationContentUpdate}
          showModalLocation={showModalLocation}
          showModalStates={showModalStates}
          showModalDetails={showModalDetails}
          showModalDetailsUpdate={this.showModalDetailsUpdate}
          showModalStatesUpdate={this.showModalStatesUpdate}
          showModalLocationUpdate={this.showModalLocationUpdate}
          hideOverlay={this.hideOverlay}
          callForSearchStores={this.callForSearchStores}
          callSearchZipStateService={this.callSearchZipStateService}
          stateOrZipSelectedUpdate={this.stateOrZipSelectedUpdate}
          storeNearSelected={storeName}
          getStoreLocation={getStoreLocationFn}
          storeLocationStates={storeLocationStates}
          storeByNear={resultStoreByNear}
          requiredLabel={(withErrorService || textFieldValid)}
          {...this.state}
          linksHeaderTop={linksHeaderTop}
          otherSites={otherSites}
          services={services}
          home={home}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  storeName: state.storeLocation.storeName,
  storeLocationStates: state.storeLocation,
  storeByNear: state.storeLocation.dataByNear,
  storeNearSelected: state.storeLocation.setNearStore,
});

const matchDispatchToProps = dispatch => bindActionCreators({
  cleanDataStoreLocation,
  getStoreLocation,
  getNearByStores,
}, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(HeaderTopContainer);
